import "../CSS/ueber.css";

import Seo from "../components/Seo";


function UeberPage() {

    return (

        <>

            <Seo
                title="Über mich"
                description="Erfahre mehr über Ivan Jörg, seinen persönlichen Hintergrund, Weiterbildungen, Werdegang, Zertifikate, Diplome und Hobbys."
                canonical="https://www.irj.ch/ueber"
            />


            <div className="intro">

                <p>
                    Auf dieser Seite erfährst Du einige Dinge über mich persönlich.
                    In den Untermenüs findest Du zusätzlich Informationen über:
                </p>

                <ul>
                    <li>Weiterbildung</li>
                    <li>Werdegang</li>
                    <li>Zertifikate</li>
                    <li>Diplome</li>
                    <li>Hobbys</li>
                </ul>

            </div>


            <main>

                <figure className="ueber-figure">

                    <img
                        src="/Fotos/meditation_ich.png"
                        alt="Ivan Jörg"
                        title="Das bin ich"
                        className="ueber-bild"
                    />

                    <figcaption>
                        Darf ich vorstellen: Das bin ich!
                    </figcaption>

                </figure>

            </main>

        </>

    );
}


export default UeberPage;